import { cn } from '@/shared/lib/utils'
import type { AssistantMessage } from '../types/assistant'

interface Props {
  message: AssistantMessage
  agentInitials: string
  agentColor: string
}

function formatText(text: string) {
  const parts = text.split(/(\*\*[^*]+\*\*)/)
  return parts.map((part, i) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      return <strong key={i}>{part.slice(2, -2)}</strong>
    }
    return part
  })
}

export function AssistantMessageBubble({ message, agentInitials, agentColor }: Props) {
  const isAgent = message.sender === 'agent'

  return (
    <div className={cn('flex gap-2', isAgent ? 'flex-row' : 'flex-row-reverse')}>
      {isAgent && (
        <div
          className={cn(
            'h-6 w-6 rounded-full flex items-center justify-center text-white text-[8px] font-bold shrink-0 mt-0.5',
            agentColor,
          )}
        >
          {agentInitials}
        </div>
      )}
      <div
        className={cn(
          'max-w-[85%] rounded-lg px-3 py-2 text-xs leading-relaxed whitespace-pre-line',
          isAgent ? 'bg-muted/70 border' : 'bg-primary text-primary-foreground',
        )}
      >
        {formatText(message.text)}
      </div>
    </div>
  )
}
